import {
	Button,
	Flex,
	Input,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Select,
	SimpleGrid,
	Stack,
	Text,
	Textarea,
	useDisclosure,
	useToast,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { getAllUsuarios } from '../../../services/usuarios';
import { crearActividad, updateActividad } from '../../../services/actividades';
import {
	errorNotification,
	okNotification,
} from '../../../utils/Notificaciones';
import { createEvent } from '../../../services/agenda';
import EasyDatePickerWithTime from '../../EasyDatePicker/EasyDatePickerWithTime';
import { TIPOS_CITAS } from '../../../data/constants';
import AdquisicionProcesoGuiado from './AdquisicionProcesoGuiado';
import { useSelector } from 'react-redux';
import EasyDatePicker from '../../EasyDatePicker/EasyDatePicker';

const AdquisicionModal = ({ isOpen, onClose, datos, isEdit }) => {
	const [responsables, setResponsables] = useState([]);
	const [needReload, setNeedReload] = useState(true);
	const [formData, setFormData] = useState(datos);
	const toast = useToast();

	const [datosEnviados, setDatosEnviados] = useState({});
	const {
		isOpen: isOpenProcesoGuiado,
		onOpen: onOpenProcesoGuiado,
		onClose: onCloseProcesoGuiado,
	} = useDisclosure();

	const { user } = useSelector(state => state.auth);

	useEffect(() => {
		const getResponsables = async () => {
			setNeedReload(false);
			const auxResponsables = await getAllUsuarios();
			setResponsables(auxResponsables);
			if (!isEdit) {
				const newDate = new Date();
				setFormData({
					...formData,
					responsableUuid: user.uuid,
					estado_actividad: 'Programada',
					modalidad_contacto: 'Llamada',
					fechaInicio: newDate,
					fechaFin: new Date(newDate.getTime() + 30 * 60000),
					fecha_actividad: newDate,
				});
			}
		};

		needReload && getResponsables();
	}, [formData, needReload, isEdit, user.uuid]);

	const handleChange = e => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const getDataForSend = () => {
		return {
			entidad_relacionada: 'Noticia',
			tipo_actividad: 'Adquisicion',
			modalidad_contacto: formData.modalidad_contacto,
			fecha_vencimiento: formData.fecha_vencimiento,
			fecha_actividad: formData.fecha_actividad,
			fecha_finalizacion:
				formData.estado_actividad === 'Realizada' ? new Date() : null,
			estado_actividad: formData.estado_actividad,
			descripcion: formData.descripcion,
			recordatorio: false,
			recordatorio_fecha: null,
			responsableUuid: formData.responsableUuid,
			clienteUuid: datos.cliente.uuid,
			noticiaUuid: datos.noticia?.uuid || datos.uuid,
			inmuebleUuid: datos.inmueble.uuid,
		};
	};

	const handleSubmit = async e => {
		e.preventDefault();

		const notificationMessage = !isEdit
			? 'Actividad creada. Cita creada'
			: 'Actividad y cita actualizada correctamente';
		const errorMessage = 'Error al crear la actividad';

		try {
			if (!isEdit) {
				const auxActividad = await crearActividad(getDataForSend());
				await createEvent({
					entidad_relacionada: 'Noticia',
					fechaInicio: formData.fechaInicio,
					fechaFin: formData.fechaFin,
					estado: 'Programada',
					tipo: 'Adquisicion',
					ubicacion: formData.ubicacion,
					descripcion: formData.descripcion,
					color: TIPOS_CITAS.find(tipo => tipo.tipo === 'Adquisicion')
						.color,
					responsableUuid: formData.responsableUuid,
					clienteUuid: datos.cliente.uuid,
					inmuebleUuid: datos.inmueble.uuid,
					actividadeUuid: auxActividad.uuid,
				});
			} else {
				await updateActividad(datos.uuid, formData);
				/*
                const evento = await updateEvent(datos.uuid, {
                    fechaInicio: formData.fechaInicio,
                    fechaFin: formData.fechaFin,
                    estado: datos.estado,
                    ubicacion: formData.ubicacion,
                    descripcion: formData.descripcion,
                });
                */
			}

			okNotification(notificationMessage, toast);
			onClose();
			window.location.reload();
		} catch (error) {
			errorNotification(errorMessage, toast);
			console.error(
				'🚀 ~ file: ActualizacionModal.js:7 ~ ActualizacionModal ~ error',
				error,
			);
		}
	};

	const handleProcesoGuiado = () => {
		const parseData = getDataForSend();
		setDatosEnviados({
			...parseData,
			responsables,
			actividadUuid: isEdit ? datos.uuid : null,
			noticia: datos,
			fechaInicio: formData.fechaInicio || new Date(),
			fechaFin:
				formData.fechaFin ||
				new Date(new Date().getTime() + 30 * 60000),
		});
		onOpenProcesoGuiado();
	};

	useEffect(() => {
		const changeFechaInicio = () => {
			try {
				setFormData(prevFormData => ({
					...prevFormData,
					fechaFin: new Date(
						prevFormData.fechaInicio.getTime() + 30 * 60000,
					),
				}));
			} catch (error) {
				console.error(
					'🚀 ~ file: GestionEncargoModal.js:127 ~ changeFechaInicio ~ error:',
					error,
				);
			}
		};

		if (formData?.fechaInicio) {
			changeFechaInicio();
		}
	}, [formData.fechaInicio]);

	let direccion;
	if (datos.inmueble && datos.inmueble.ubicacion) {
		try {
			direccion = JSON.parse(datos.inmueble.ubicacion)?.direccion;
		} catch (error) {
			direccion = JSON.parse(
				JSON.stringify(datos.inmueble.ubicacion),
			)?.direccion;
		}
	}

	const abrirProcesoGuiado =
		formData.estado_actividad === 'Realizada' ||
		datos.estado_actividad === 'Realizada';

	return (
		<>
			<Modal isOpen={isOpen} onClose={onClose} size='3xl' isCentered>
				<ModalOverlay bgColor='blackAlpha.800' />
				<ModalContent>
					<ModalHeader>Cita de adquisición</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Stack direction='column' spacing={4}>
							<SimpleGrid
								columns={{ base: 1, md: 2 }}
								spacing={{ base: 1, md: 0 }}
							>
								<Text>Cliente</Text>
								<Input
									name='cliente'
									value={`${datos.cliente?.nombre} ${datos.cliente?.apellidos}`}
									isReadOnly
									isDisabled
								/>
							</SimpleGrid>

							<SimpleGrid
								columns={{ base: 1, md: 2 }}
								spacing={{ base: 1, md: 0 }}
							>
								<Text>Entidad relacionada</Text>
								<Input
									name='entidad'
									value={`NT - ${datos.inmueble?.tipo_inmueble} ${datos.inmueble?.subtipo_inmueble} - ${direccion}`}
									isReadOnly
									isDisabled
								/>
							</SimpleGrid>

							<SimpleGrid
								columns={{ base: 1, md: 2 }}
								spacing={{ base: 1, md: 0 }}
							>
								<Text>Modalidad contacto</Text>
								<Select
									name='modalidad_contacto'
									isDisabled={datos.fecha_finalizacion}
									value={formData.modalidad_contacto}
									onChange={handleChange}
								>
									<option value='Llamada'>Llamada</option>
									<option value='Presencial'>
										Presencial
									</option>
								</Select>
							</SimpleGrid>

							<SimpleGrid
								columns={{ base: 1, md: 2 }}
								spacing={{ base: 1, md: 0 }}
							>
								<Text>Responsable</Text>
								<Select
									name='responsableUuid'
									isDisabled={datos.fecha_finalizacion}
									value={formData.responsableUuid}
									onChange={handleChange}
								>
									{responsables.map(responsable => (
										<option
											key={responsable.uuid}
											value={responsable.uuid}
										>
											{responsable.nombre}{' '}
											{responsable.apellidos}
										</option>
									))}
								</Select>
							</SimpleGrid>

							<SimpleGrid
								columns={{ base: 1, md: 2 }}
								spacing={{ base: 1, md: 0 }}
							>
								<Text>Fecha actividad</Text>
								<EasyDatePicker
									name='fecha_actividad'
									value={formData.fecha_actividad}
									handleChange={
										datos.fecha_finalizacion
											? null
											: handleChange
									}
								/>
							</SimpleGrid>

							{!datos.fecha_finalizacion && !isEdit && (
								<>
									<SimpleGrid
										columns={{ base: 1, md: 2 }}
										spacing={{ base: 1, md: 0 }}
									>
										<Text>Fecha inicio</Text>
										<EasyDatePickerWithTime
											name='fechaInicio'
											value={formData.fechaInicio}
											handleChange={
												datos.fecha_finalizacion
													? null
													: e =>
															setFormData({
																...formData,
																fechaInicio: e,
															})
											}
										/>
									</SimpleGrid>

									<SimpleGrid
										columns={{ base: 1, md: 2 }}
										spacing={{ base: 1, md: 0 }}
									>
										<Text>Fecha fin</Text>
										<EasyDatePickerWithTime
											name='fechaFin'
											value={formData.fechaFin}
											handleChange={
												datos.fecha_finalizacion
													? null
													: e =>
															setFormData({
																...formData,
																fechaFin: e,
															})
											}
										/>
									</SimpleGrid>
								</>
							)}

							<SimpleGrid
								columns={{ base: 1, md: 2 }}
								spacing={{ base: 1, md: 0 }}
							>
								<Text>Estado</Text>
								<Select
									name='estado_actividad'
									value={formData.estado_actividad}
									onChange={handleChange}
									isDisabled={datos.fecha_finalizacion}
								>
									<option value='Programada'>
										Programada
									</option>
									<option value='Realizada'>Realizada</option>
								</Select>
							</SimpleGrid>

							<Text>Descripción</Text>
							<Textarea
								isDisabled={datos.fecha_finalizacion}
								borderLeft='3px solid red'
								name='descripcion'
								value={formData.descripcion}
								onChange={handleChange}
								minH='90px'
							/>
							{datos && !datos.fecha_finalizacion && (
								<Flex gap={0}>
									<Button
										w='100%'
										rounded='none'
										onClick={handleSubmit}
										colorScheme='green'
									>
										{isEdit ? 'EDITAR' : 'CREAR'}
									</Button>
									{abrirProcesoGuiado && (
										<Button
											w='100%'
											rounded='none'
											onClick={handleProcesoGuiado}
											colorScheme='blue'
										>
											PROCESO GUIADO
										</Button>
									)}
								</Flex>
							)}
						</Stack>
					</ModalBody>
				</ModalContent>
			</Modal>
			{isOpenProcesoGuiado && (
				<AdquisicionProcesoGuiado
					isOpen={isOpenProcesoGuiado}
					onClose={onCloseProcesoGuiado}
					datos={datosEnviados}
					onClosePadre={onClose}
				/>
			)}
		</>
	);
};

export default AdquisicionModal;
